import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../lib/utils'

const textVariants = cva('leading-7', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
    },
    color: {
      default: 'text-foreground',
      muted: 'text-muted-foreground',
      destructive: 'text-destructive',
    },
  },
  defaultVariants: {
    size: 'base',
    weight: 'normal',
    color: 'default',
  },
})

export interface TextProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
  VariantProps<typeof textVariants> {
  as?: 'p' | 'span' | 'div' | 'label' | 'small'
}

export const Text = React.forwardRef<HTMLElement, TextProps>(
  ({ as: Comp = 'p', className, size, weight, color, ...props }, ref) => (
    <Comp
      ref={ref as any}
      className={cn(textVariants({ size, weight, color }), className)}
      {...props}
    />
  ),
)
Text.displayName = 'Text'
